if (!customElements.get('config-select')) {
  class ConfigSelect extends HTMLElement {
    constructor() {
      super();
    }

    /**
     * @param {Event} event
     */
    handleChange(event) {
      event.preventDefault();
      // @ts-ignore
      const value = event.target.value;
      if(!value) return;

      window.location.href = value;
    }

    connectedCallback() {
      this.addEventListener('change', this.handleChange.bind(this));

      const select = document.getElementById("BaseProduct");
      if(!select) return;
      // @ts-ignore
      select.value = "";

      window.addEventListener("pageshow", (e) => {
        if (e.persisted) {
          // @ts-ignore
          select.value = "";
        }
      });
    }
  }

  customElements.define('config-select', ConfigSelect);
}